import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchSizes, fetchBrands } from "../lib/api";
import { Search } from "lucide-react";

const TyreSearchBar = ({ showBrand = false }) => {
  const [sizes, setSizes] = useState({ widths: [], profiles: [], rims: [] });
  const [brands, setBrands] = useState([]);
  const [width, setWidth] = useState("");
  const [profile, setProfile] = useState("");
  const [rim, setRim] = useState("");
  const [brand, setBrand] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchSizes().then(setSizes).catch(() => {});
    if (showBrand) fetchBrands().then(setBrands).catch(() => {});
  }, [showBrand]);

  const onSubmit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (width) params.set("width", width);
    if (profile) params.set("profile", profile);
    if (rim) params.set("rim", rim);
    if (brand) params.set("brand", brand);
    navigate(`/tyres${params.toString() ? `?${params.toString()}` : ""}`);
  };

  const cols = showBrand ? "grid-cols-2 sm:grid-cols-5" : "grid-cols-2 sm:grid-cols-4";

  return (
    <form
      onSubmit={onSubmit}
      className={`vd-card p-3 sm:p-4 grid gap-3 ${cols}`}
      style={{ background: "var(--card-bg)" }}
      data-testid="tyre-search-bar"
    >
      <select className="vd-select" value={width} onChange={(e) => setWidth(e.target.value)} data-testid="search-width">
        <option value="">Width</option>
        {sizes.widths.map((w) => <option key={w} value={w}>{w}</option>)}
      </select>
      <select className="vd-select" value={profile} onChange={(e) => setProfile(e.target.value)} data-testid="search-profile">
        <option value="">Profile</option>
        {sizes.profiles.map((p) => <option key={p} value={p}>{p}</option>)}
      </select>
      <select className="vd-select" value={rim} onChange={(e) => setRim(e.target.value)} data-testid="search-rim">
        <option value="">Rim</option>
        {sizes.rims.map((r) => <option key={r} value={r}>R{r}</option>)}
      </select>
      {showBrand && (
        <select className="vd-select" value={brand} onChange={(e) => setBrand(e.target.value)} data-testid="search-brand">
          <option value="">Brand</option>
          {brands.map((b) => <option key={b.id} value={b.name}>{b.name}</option>)}
        </select>
      )}
      <button type="submit" className="vd-btn-primary" data-testid="search-find-tyres-btn">
        <Search size={18} /> Find Tyres
      </button>
    </form>
  );
};

export default TyreSearchBar;
